import { redirect } from "react-router-dom";
import { AbsoluteCenter, Box, Heading, Stack } from "@chakra-ui/react";

import { useLoginFormStore } from "../../store/loginFormStore.ts";
import { EPhoneFormState } from "../../store/slices/phoneFormSliceCreator.ts";
import { PassportForm } from "../../components/features/LoginPage/PassportForm";
import { isNewAuthorization, useAuthorizationStore } from "../../store/authorizationStore";

export function PassportPage() {
  return (
    <Box position="relative" h="calc(100vh - 84px * 2)">
      <AbsoluteCenter axis="both">
        <Stack spacing={9} minW="300px" pb="150px">
          <div>
            <Heading textAlign="center">Подтверждение личности</Heading>
          </div>
          <PassportForm />
        </Stack>
      </AbsoluteCenter>
    </Box>
  );
}

PassportPage.loader = () => {
  if (isNewAuthorization()) {
    const auth = useAuthorizationStore.getState();
    if (auth.restoringPin && auth.flow !== "REG") {
      return redirect(auth.authSessionId ? "/login/pin" : "/login");
    }

    return auth.authSessionId && auth.flow === "REG" ? null : redirect("/login");
  }

  const formState = useLoginFormStore.getState();
  if (formState.phoneFormState !== EPhoneFormState.submitted || !formState.smsCode) {
    return redirect("/login");
  }
  return null;
};
